import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Storage from '../services/Storage';
import { mainPrivateRoutesArr } from './mainPrivateRoutesArr';
import ThemeOptions from '../Layout/ThemeOptions';
import AppHeader from '../Layout/AppHeader';
import AppSidebar from '../Layout/AppSidebar';
import { Permissions } from '../constants/Permissions';
// import { Dashboard } from '../Pages/Dashboard/Dashboard';

const MainPrivateRoutes = () => {
    let isMobile = false;
    let routeArr = [];
    const { search } = useLocation();
    isMobile = new URLSearchParams(search).get('isMobile');
    const token = Storage.getTokenDetail() || {};
    const { permissionArr } = useSelector(state => state.UserGetReducer)
    let permissions = permissionArr;

    if (permissions && permissions.length) {
        for (let i = 0; i < mainPrivateRoutesArr.length; i++) {
            let currentPermission = mainPrivateRoutesArr[i].permissions;
            const found = currentPermission.some((r) => permissions.indexOf(r) >= 0);
            if (found) {
                routeArr.push(mainPrivateRoutesArr[i]);
            }
        }
    }

    return (
        <>
            {/* <ThemeOptions />
            {(isMobile === 'false' || isMobile === null) ? <AppHeader /> : ''}
            <div className='app-main' style={{ paddingTop: `${(isMobile === 'false' || isMobile === null) ? '60px' : '0px'}` }}>
                {(isMobile === 'false' || isMobile === null) ? <AppSidebar /> : ''}
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'> */}
                        <Routes>
                            {routeArr.map((route, index) => {
                                return (
                                    <Route
                                        key={index}
                                        path={`${route.path}`}
                                        element={<route.component />}
                                    />
                                );
                            })}
                            {routeArr && routeArr.length > 0 &&
                                <Route
                                path="/*"
                                element={(!token.accessToken) ? <Navigate to="/user/login" replace /> : permissions && permissions.length > 0 && permissions.includes(Permissions.CNF_DASHBOARD) ? <Navigate to="/cnf/cnf-dashboard" /> : <Navigate to="/agrocel/dashboard" />}
                            />
                            }
                            {/* <Route path='*' element={(!token.accessToken) ? <Navigate to="/user/login" replace /> : <Navigate to="/agrocel/dashboard" />} /> */}
                            {/* <Route path='*' element={<Dashboard />} replace /> */}
                        </Routes>
                    {/* </div>
                </div>
            </div> */}
        </>
    )
}

export default MainPrivateRoutes
